module.exports = __webpack_public_path__ + "img/about-us-introction.9e259586.jpg";